import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Card from '../../../SharedComponents/Card'
import Spinner from '../../../SharedComponents/Spinner'
import axios from 'axios'
import config from '../../../../config.json';
import { NotificationManager } from 'react-notifications';
import AddTelecomExam from './AddTelecomExam';

export default function TelecomExamsList() {
    const [loading, setLoading] = useState(false)
    const { id } = useParams();
    const [telecomExams, setTelecomExams] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        getTelecomExams();
    }, [])

    const getTelecomExams = () => {
        setLoading(true);
        axios({
            method: 'get',
            url: `${config.SERVER_URL}/patients/${id}/exams/telecom`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('token')
            },
        })
            .then(res => {
                if (typeof (res.data) === "string") {
                    // NotificationManager.info(res.data)
                } else {
                    setTelecomExams(res.data);
                }

            })
            .catch(err => {
                if (err.response.status === 401) {
                    navigate('/signin')
                }
                NotificationManager.error(err.response.data)
            })
            .finally(() => setLoading(false));
    }

    const handleExamAdded = () => {
        getTelecomExams();
    };


    return (
        <>
            {loading ? <Spinner /> : null}
            <Card title={'ЕХО и Ултразвучни Прегледи'}>
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Работен лист</th>
                            <th scope="col">Уред</th>
                            <th scope="col">Закажан датум</th>
                            <th scope="col" style={{ width: '165px', paddingTop: '0' }}>
                                <button
                                    type="button"
                                    className="btn align-self-end"
                                    style={{ backgroundColor: "#39828f", color: "#fff" }}
                                    onClick={() => setShowModal(true)}
                                >
                                    Креирај преглед
                                </button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {telecomExams.map((exam, index) => {
                            const scheduledDate = new Date(exam.scheduled_date);
                            return (
                                <tr key={exam.id}>
                                    <th>{index + 1}</th>
                                    <td>{exam.worklist_id}</td>
                                    <td>{exam.device_label || '-'}</td>
                                    <td>{`${scheduledDate.getDate()}/${scheduledDate.getMonth() + 1 < 10 ? '0' + (scheduledDate.getMonth() + 1) : (scheduledDate.getMonth() + 1)}/${scheduledDate.getFullYear()} ${scheduledDate.getHours()}:${scheduledDate.getMinutes() < 10 ? '0' + scheduledDate.getMinutes() : scheduledDate.getMinutes()}`}</td>
                                    <td></td>
                                </tr>
                            )
                        })}

                    </tbody>
                </table>
            </Card>

            <AddTelecomExam
                show={showModal}
                handleClose={() => setShowModal(false)}
                patientId={id}
                onExamAdded={handleExamAdded}
            />
        </>
    )
}
